import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';

import {
  openRtbMediaRtbDetail,
  openRtbChildDetail,
  openRtbsetOnOffMedia,
  openRtbSetting,
  openRtbStateLog,
  openRtbWeightGet,
} from 'lib/api/openrtb';
import {
  makeRowColumn,
  getHeadObj,
  converParameters,
  conversionParams,
  under2camel,
  getHost,
} from 'lib/commonLib';
import { paramConverter } from 'modules/common';

import CurrentStatus from 'components/atoms/CurrentStatus';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import Dialog from 'components/organisms/Dialog';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

import Modal from './Modal';

const useStyles = makeStyles((theme) => ({
  stateBox: {
    padding: '5px 10px',
    borderRadius: 5,
    color: theme.palette.common.white,
  },
}));

const MediaDetailPopup = (props) => {
  const { location, handlePortalUrl, handleClickSnackbar } = props;
  const locationSearch = queryString.parse(location.search);
  const classes = useStyles();
  const theme = useTheme();
  const { allProductCodeList, productCodeList } = useSelector(({ common }) => ({
    allProductCodeList: common.allProductCodeList,
    productCodeList: common.productCodeList,
  }));
  const { t } = useTranslation();
  const initModal = {
    open: false,
    type: null,
    params: {},
    data: [],
    headerTitle: '',
  };
  const initDialog = {
    open: false,
    sectionText: t('선택한 지면을 중지 하시겠습니까?'),
  };
  const [modal, setModal] = useState(initModal);
  const [dialog, setDialog] = useState(initDialog);
  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    uri: '/manage/openrtb/media_rtb/detail',
    state: '01',
  };

  const converParams = conversionParams(
    productCodeList,
    locationSearch,
    allProductCodeList
  );
  initParams = { ...initParams, ...converParams };
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);
  const [loading, setLoading] = useState(true);
  const [reFetch, setReFetch] = useState(false);
  const [weightList, setWeightList] = useState([]);
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    if (!!initParams['tp_code']) {
      initParams['itlTpCode'] = initParams.tp_code;
    }
    if (!!initParams['mediaScriptNo']) {
      initParams['mediaScrtHirnkNo'] = initParams.mediaScriptNo;
    }
    delete initParams['tp_code'];
    delete initParams['mediaScriptNo'];
    delete initParams['kakaoH'];
    setParams(initParams);
    openRtbWeightGet()
      .then((response) => {
        const { data } = response.data;
        setWeightList(data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .then(() => {
        setLoading(false);
      }); // eslint-disable-next-line
  }, []);

  const customized = {
    MANAGE_ICONS: {
      makeBody: (rowObj, headsMap) => {
        return (
          !!rowObj['FIXED'] &&
          rowObj['FIXED'] !== 0 && (
            <TableBtnWrap>
              <NewButton
                title={t('RTB 지면 이력 확인')}
                iconBtn
                icon="faExternalLink"
                disableRipple
                onClick={() => {
                  handleGetDetail(rowObj, 'history');
                }}
              />
              <NewButton
                title={t('수정')}
                iconBtn
                icon="faEdit"
                disableRipple
                onClick={() => {
                  handleGetDetail(rowObj, 'modify');
                  setModal({});
                }}
              />
            </TableBtnWrap>
          )
        );
      },
    },
    REG_DTTM: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'REG_DTTM');
        return (
          rowObj['FIXED'] !== 0 &&
          makeRowColumn(rowObj['REG_DTTM'], bodyItem1.type, bodyItem1.format)
        );
      },
    },
    CTGR_NM: { merged: true },
    PLTFOM_TP_NAME: { merged: true },
    IMAGE_SIZE_NAME: { merged: true },
    BID_RATE: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BID_RATE');
        return makeRowColumn(rowObj['BID_RATE'], bodyItem1.type, '0.00%');
      },
    },
    WIN_BID_RATE: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'WIN_BID_RATE');
        return makeRowColumn(rowObj['WIN_BID_RATE'], bodyItem1.type, '0.00%');
      },
    },
    STATE: {
      makeBody: (rowObj, headsMap) => {
        const stateOn = rowObj['STATE'] === '01';
        return (
          rowObj['FIXED'] !== 0 && (
            <div
              className={classes.stateBox}
              style={{
                backgroundColor: stateOn
                  ? theme.palette.common.green
                  : theme.palette.common.red,
              }}
            >
              {stateOn ? 'ON' : 'OFF'}
            </div>
          )
        );
      },
    },
    CLICK_CNT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CLICK_CNT');
        const showWindowUrl = converParameters({
          url: getHost('new') + '/report/adver/statistics',
          advrtsPrdtCode: params['advrtsPrdtCode'],
          advrtsTpCode: params['advrtsTpCode'],
          sDate: params['sDate'],
          eDate: params['eDate'],
          pltfomTpCode: params['pltfomTpCode'],
          mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
          itlTpCode: params['itlTpCode'],
          table: 'kakao_popup',
          isPop: 1,
          popGroup: 'adver',
        });
        return rowObj['FIXED'] !== 0 ? (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['CLICK_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            icon={
              rowObj['STATS_DTTM'] !== 'total' &&
              rowObj['PLTFOM_TP_CODE'] === undefined &&
              'faExternalLink'
            }
            toolTipTitle={t('광고주별 통계')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        ) : (
          makeRowColumn(rowObj['CLICK_CNT'], bodyItem1.type, bodyItem1.format)
        );
      },
    },
    MC_POINT: { orderFlag: true },
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
    }
  };

  const getTableParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const getTempParam = (newParams) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const getModalParams = (newParams) => {
    if (JSON.stringify(modal.params) !== JSON.stringify(newParams)) {
      setModal({ ...modal, params: newParams });
    }
  };

  const headCallBack = (type, data) => {
    let tmpExlNo = [];
    data.forEach(function (rowData) {
      tmpExlNo.push(rowData['MEDIA_SCRIPT_NO']);
    });
    let newModal = { ...initModal, open: true, type: type, params: {} };
    let newParams = {
      mediaScriptNo: String(tmpExlNo),
      cpcFlag: '01',
      cpmFlag: '02',
    };
    if (type === 'edit') {
      for (let targetCode of weightList) {
        if (!!targetCode) {
          const codeInfo = allProductCodeList.find(
            (element) => element['value'] === targetCode
          );
          if (
            codeInfo['codeVal'] === 'CW' ||
            codeInfo['codeVal'] === 'PF' ||
            codeInfo['codeVal'] === 'TC'
          ) {
            newParams[under2camel(codeInfo['codeVal'] + '_cpc_send')] = '02';
          } else {
            newParams[under2camel(codeInfo['codeVal'] + '_cpc_send')] = '01';
          }
          newParams[under2camel(codeInfo['codeVal'] + '_cpc_weight')] = '100';
          newParams[under2camel(codeInfo['codeVal'] + '_cpm_weight')] = '100';
        }
      }
      newModal['headerTitle'] = t('가중치 설정');
      setModal({ ...newModal, params: newParams });
    } else if (type === 'stop') {
      setDialog({
        ...initDialog,
        open: true,
        params: { mediaScriptNo: String(tmpExlNo) },
      });
    }
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (rowObj) => {
        return '';
      },
    });
    return result;
  })();

  const handleGetDetail = (rowObj, type) => {
    if (type === 'modify') {
      openRtbChildDetail({ mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'] })
        .then((response) => {
          const { data } = response.data;
          let newData = { mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'] };
          for (let key in data) {
            newData[under2camel(key)] = data[key];
          }
          setModal({
            ...initModal,
            open: true,
            type: type,
            params: newData,
            headerTitle: t('지면 상세보기'),
          });
        })
        .catch((error) => {
          handleClickSnackbar({ message: error, option: { type: 'error' } });
        });
    } else if (type === 'history') {
      openRtbStateLog({
        mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
        itlTpCode: params['itlTpCode'],
      })
        .then((response) => {
          const { data } = response.data;
          if (data.length === 0) {
            handleClickSnackbar({
              message: rowObj['SITE_NAME'] + '의 데이터가 없습니다.',
              option: { type: 'info' },
            });
          } else {
            setModal({
              ...initModal,
              open: true,
              type: 'history',
              params: { sort: 'desc', order: 'REG_DTTM' },
              data: data,
              headerTitle: t('RTB 지면 이력 확인'),
            });
          }
        })
        .catch((error) => {
          handleClickSnackbar({ message: error, option: { type: 'error' } });
        });
    }
  };

  const handleSubmit = (newParams) => {
    let tempParams = { ...newParams };
    if (modal['type'] === 'modify' || modal['type'] === 'edit') {
      if (tempParams['cpcFlag'] === '02') {
        delete tempParams['setCpcWeightStr'];
      }
      if (tempParams['cpmFlag'] === '02') {
        delete tempParams['setCpmWeightStr'];
      }
      delete tempParams['cpcFlag'];
      delete tempParams['cpmFlag'];
      if (
        tempParams['setCpcWeightStr'] === undefined &&
        tempParams['setCpmWeightStr'] === undefined
      ) {
        handleClickSnackbar({
          message: t('선택된 수정사항이 없습니다.'),
          option: { type: 'error' },
        });
      } else {
        openRtbSetting(paramConverter(tempParams))
          .then((response) => {
            const { message } = response.data;
            handleClickSnackbar({
              message: message,
              option: { type: 'success' },
            });
            setReFetch(true);
          })
          .catch((error) => {
            handleClickSnackbar({ message: error, option: { type: 'error' } });
          })
          .then(() => {
            setModal(initModal);
            setReFetch(false);
          });
      }
    }
  };

  const handleDialogClose = () => {
    setDialog(initDialog);
  };

  const handleDialogSubmit = () => {
    openRtbsetOnOffMedia({
      mediaNo: dialog['params']['mediaScriptNo'],
      state: '02',
    })
      .then((response) => {
        const { message } = response.data;
        handleClickSnackbar({ message: message, option: { type: 'success' } });
        setReFetch(true);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .then(() => {
        setDialog(initDialog);
        setReFetch(false);
      });
  };

  const handleDataCallBack = (data) => {
    setPageTitle(data);
  };

  return (
    <>
      {loading ? (
        <CurrentStatus type="loading" option="useMinHeight" />
      ) : (
        <>
          {!!pageTitle && <h3>{pageTitle}</h3>}
          <NewFilterWrap>
            <NewCommonFilter
              params={tempParams}
              getParam={getTempParam}
              usePltfomTpCodeFilter={false}
              useDisplayFilter={false}
              externalType="select"
            />
            <FilterCollection
              label={t('지면상태')}
              value={tempParams.state}
              name="state"
              type="checkbox"
              params={tempParams}
              list={[
                { label: 'ON', value: '01' },
                { label: 'OFF', value: '02' },
              ]}
              labelKey="label"
              valueKey="value"
              callBack={getTempParam}
              popoverWidth={350}
            />
            <NewButton type="filterButton" onClick={getParam} disableRipple>
              {t('검색')}
            </NewButton>
          </NewFilterWrap>
          <NewTableContainer
            params={params}
            dataReqPromise={openRtbMediaRtbDetail}
            getParam={getTableParam}
            customized={customized}
            useCheckBox
            hasActController={{ edit: true, stop: true }}
            headCallBack={headCallBack}
            addColumnList={addColumnList}
            isIncludingTotal
            reFetch={reFetch}
            dataCallBack={handleDataCallBack}
          />
          {modal['open'] && (
            <Modal
              modal={modal}
              getParam={getModalParams}
              handleSubmit={handleSubmit}
              handleModalClose={(f) => setModal(initModal)}
              handleClickSnackbar={handleClickSnackbar}
              weightList={weightList}
            />
          )}
          <Dialog
            dialog={dialog}
            handleClose={handleDialogClose}
            handleSubmit={handleDialogSubmit}
          />
        </>
      )}
    </>
  );
};

export default withRouter(MediaDetailPopup);
